const SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'ods', 'fods']
  .map(function (x) {
    return '.' + x
  })
  .join(',')
export default SheetJSFT
